import React from 'react';
import { Pill, Utensils, Zap, Scissors, CheckCircle } from 'lucide-react';
import { treatmentOptions } from '../../data/mock';

const iconMap = {
  Pill: Pill,
  Utensils: Utensils,
  Zap: Zap,
  Scissors: Scissors
};

const TreatmentSection = () => {
  return (
    <section className="py-16 sm:py-24 bg-white relative">
      {/* Curved top transition */}
      <div className="absolute top-0 left-0 right-0 h-12 sm:h-20 bg-gray-50" style={{clipPath: 'ellipse(60% 100% at 50% 0%)'}}></div>
      
      <div className="max-w-7xl mx-auto px-6 sm:px-6 lg:px-8 pt-6 sm:pt-10">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">
            Treatment Options
          </h2>
          <p className="text-sm sm:text-lg text-gray-500">
            Modern treatments offer hope — not all stones need surgery
          </p>
        </div>

        {/* Treatment Cards Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6 mb-8 sm:mb-12">
          {treatmentOptions.map((treatment) => {
            const IconComponent = iconMap[treatment.icon];
            return (
              <div
                key={treatment.id}
                className="bg-gray-50 rounded-xl sm:rounded-2xl p-4 sm:p-8 border border-gray-100 hover:border-teal-200 hover:shadow-lg hover:bg-white transition-all duration-300 group"
              >
                <div className="w-10 h-10 sm:w-14 sm:h-14 bg-teal-50 rounded-lg sm:rounded-xl flex items-center justify-center mb-3 sm:mb-6 group-hover:bg-teal-100 transition-colors">
                  <IconComponent className="w-5 h-5 sm:w-7 sm:h-7 text-teal-500" />
                </div>
                <h3 className="text-sm sm:text-lg font-semibold text-gray-900 mb-1 sm:mb-2">
                  {treatment.title}
                </h3>
                <p className="text-gray-500 text-xs sm:text-sm leading-relaxed">
                  {treatment.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Good News Box */}
        <div className="bg-teal-50 border border-teal-100 rounded-xl sm:rounded-2xl p-5 sm:p-8">
          <div className="flex items-start gap-3 sm:gap-4">
            <div className="w-8 h-8 sm:w-10 sm:h-10 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
              <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5 text-teal-600" />
            </div>
            <div>
              <h4 className="font-semibold text-teal-700 mb-1 text-sm sm:text-base">Good News!</h4>
              <p className="text-teal-600 text-xs sm:text-base">
                Not every kidney stone needs surgery. Many patients recover fully with simple, non-invasive treatments.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TreatmentSection;
